import React from "react";
import { Skeleton } from "../../../Skeleton/Skeleton";
import { Button } from "../../../Button/Button";

import ArrowRightIcon from "../../../../icons/ArrowRightIcon";
import TruBeLogo from "../../../../icons/TruBeLogo";

export const UpcomingClassPlaceholder = ({
  className,
  imgClassName,
  showRsvpCta,
}) => (
  <div
    className={`tbk-bg-white tbk-shadow-trube_ tbk-overflow-hidden ${className}`}
  >
    <Skeleton
      className={`tbk-mb-2 tbk-flex tbk-items-center tbk-justify-center tbk-rounded-2xl tbk-bg-blue-grey-light ${imgClassName}`}
    >
      <TruBeLogo />
    </Skeleton>
    {showRsvpCta && (
      <Skeleton>
        <Button
          variant="secondary"
          size="md"
          className="tbk-w-full"
          endIcon={<ArrowRightIcon />}
          // disabled={true}
        >
          Loading
        </Button>
      </Skeleton>
    )}
  </div>
);

export default UpcomingClassPlaceholder;
